import {isInViewport} from 'src/utils/base';
import {getQueryParam} from '../../utils/url';

class GtmListing {
  constructor() {
    this.fireImpression = this.fireImpression.bind(this);
    this.selectItemEcomEvent = this.selectItemEcomEvent.bind(this);
    document.addEventListener('DOMContentLoaded', this.fireImpression);
    $(document).on('click', '.pc-ProductCard-link', this.selectItemEcomEvent);
  }

  // Private

  fireImpression() {
    if ($('.pc-Styles').length && ProductCatalog.Styles.cards().length > 0) {
      this.listingImpression();
      this.listingEcomEvent();
    } else {
      setTimeout(() => this.fireImpression(), 1000);
    }
  }
  isInTestGroup = () => {
    return Signalman.featureFlagFromCookie('search_header_v4');
  };
  toSwatch(e) {
    const swatch = $(e.target);
    if (swatch.is('.pc-Swatch')) {
      return swatch;
    }
    return swatch.closest('.pc-Swatch');
  }

  listingImpression() {
    const list = this.listingImpressionName();
    const cards = ProductCatalog.Styles.cards().slice(0, 9).toArray();
    for (let index = 0; index < cards.length; index++) {
      const card = cards[index];
      const data = $(card).find('.pc-ProductCard-dataLayer').data();
      if (data) {
        data.position = index + 1;
        data.list = list;
        ProductCatalog.gtmEvent(
          'listingImpression',
          'listingsImpression',
          data
        );
      }
    }
    return undefined;
  }

  listingImpressionName() {
    if (ProductCatalog.Styles.isSearchResults()) {
      return 'Search Results';
    } else if (ProductCatalog.Styles.isCustom()) {
      return 'Listing Custom';
    } else {
      return 'Listing';
    }
  }

  listingEcomEvent() {
    const cards = ProductCatalog.Styles.cards().slice(0, 9).toArray();
    const category_tree = $('meta[property=categoryinfo]').attr(
      'category_tree'
    );
    const items = cards.map((card, index) => {
      return {
        item_id: parseInt(card.dataset['styleId']),
        item_name: card.dataset['styleName'],
        index: index + 1,
        item_brand: card.dataset['brandName'],
        item_category: card.dataset['itemCategory'],
        item_category2: card.dataset['itemCategory2'],
        item_category3: card.dataset['itemCategory3']
      };
    });
    const ecommerce = {
      item_list_id: parseInt($('meta[property=categoryinfo]').prop('id')),
      item_list_name: category_tree,
      items: items
    };

    ProductCatalog.gtmEcomEvent('view_item_list', {
      search_term: getQueryParam('keyword'),
      search_header_v4: this.isInTestGroup(),
      ecommerce
    });
    ProductCatalog.gtmEcomEvent('header_search_results', {
      search_term: getQueryParam('keyword'),
      search_header_v4: this.isInTestGroup(),
      search_location: window.location.href
    });
    return undefined;
  }

  selectItemEcomEvent(e) {
    const $card = $(e.currentTarget).parents('.pc-ProductCard');
    const data = $card.find('.pc-ProductCard-ecomDataLayer').data();
    if (data) {
      const item = data.items[0];
      // Position of current card on the page
      item.index = $('.pc-ProductCard').index($card) + 1;
      item.item_list_name = this.listingImpressionName();
      const ecommerce = {
        item_list_id: parseInt($('meta[property=categoryinfo]').prop('id')),
        item_list_name: $('meta[property=categoryinfo]').attr('category_tree'),
        items: [item]
      };
      ProductCatalog.gtmEcomEvent('select_item', {
        search_term: getQueryParam('keyword'),
        search_header_v4: this.isInTestGroup(),
        ecommerce
      });
    }
    return undefined;
  }
}

ProductCatalog.GtmListing = new GtmListing();
